var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.tag, _vm._b({
    tag: "component",
    staticClass: "list-item nav-list-item",
    class: [{
      'list-item-parent': _vm.hasChildren
    }, _vm.level ? ("list-item-level-" + (_vm.level)) : '', _vm.sizeString ? 'nav-list-item-' + _vm.sizeString : '', _vm.roundedString, _vm.colorString ? 'text-' + _vm.colorString : ''],
    style: _vm.style,
    attrs: {
      "role": "listitem"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.handleClick.apply(null, arguments);
      }
    }
  }, 'component', _vm.linkProps, false), [_vm.level >= 3 && _vm.isActive ? _c('span', {
    staticClass: "active-border",
    style: {
      backgroundColor: _vm.activeColorHex
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between items-center w-full h-full"
  }, [_vm._v("\n        " + _vm._s(_vm.text) + "\n        "), _vm._t("default"), _vm._v(" "), _vm.hasChildren || _vm.$slots.right ? _c('div', {
    staticClass: "flex items-center justify-end h-full ml-4"
  }, [_vm._t("right"), _vm._v(" "), _vm.hasChildren ? _c('icon', {
    staticClass: "ml-2",
    attrs: {
      "color": _vm.textColor ? _vm.textColor : 'gray-400',
      "small": "",
      "force-size": "",
      "icon": _vm.isActive ? _vm.$icons.up : _vm.$icons.down
    }
  }) : _vm._e()], 2) : _vm._e()], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }